import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ThunkDispatch } from 'redux-thunk';
import { ReduxState } from 'src/types/reduxState';
import { Action } from 'redux';
import getClassName from 'src/common/utils/getClassName';
import { logoutThunk } from '../../ducks/user';
import { homepageRedirect } from '../../utils/routing';
import IconDS22 from '../IconDS22';
import s from './Navigation.module.scss';

type Props = {
  className?: string;
};

const LogoutButton: FC<Props> = ({ className = '' }) => {
  const dispatch = useDispatch<ThunkDispatch<ReduxState, {}, Action>>();

  const logout = useCallback(async () => {
    const redirectToHome = await dispatch(logoutThunk());
    if (redirectToHome) {
      homepageRedirect();
    }
  }, [dispatch]);

  return (
    <button
      onClick={logout}
      className={className}
      type="button"
    >
      <IconDS22
        id="logout"
        size="m"
        className={getClassName(s, 'iconDS22', 'subNav logout nestedMenu')}
      />
      Sign Out
    </button>
  );
};

export default LogoutButton;
